import React, { Fragment } from 'react'
import { Timeline, Typography } from 'antd'
import { map } from 'lodash'

import { EVENT_SUBTYPES, EVENT_TYPES } from '../../common/constants'
import {
  renderSimpleUpdateEvent,
  renderTreeSaveEvent,
} from '../../common/helpers'
import { formatCreatedByText } from '../../common/utils'

const renderDietEvent = event => {
  const { type, subtype, original, changes, createdAt, createdBy } = event

  if (type === EVENT_TYPES.SAVE) {
    return renderTreeSaveEvent(event)
  }

  if (subtype === EVENT_SUBTYPES.EXCLUDED_ALLERGENS_CREATE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>
          Created excluded allergens for {changes.name}:
        </Typography.Text>
        <br />
        {map(changes.excludedAllergens, ({ id, name }) => (
          <Fragment key={id}>
            <Typography.Text>{name}</Typography.Text>
            <br />
          </Fragment>
        ))}
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  if (subtype === EVENT_SUBTYPES.EXCLUDED_ALLERGENS_DELETE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>
          Deleted excluded allergens from {original.name}:
        </Typography.Text>
        <br />
        {map(original.excludedAllergens, ({ id, name }) => (
          <Fragment key={id}>
            <Typography.Text>{name}</Typography.Text>
            <br />
          </Fragment>
        ))}
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  if (subtype === EVENT_SUBTYPES.EXCLUDED_INGREDIENTS_CREATE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>
          Created excluded ingredients for {changes.name}:
        </Typography.Text>
        <br />
        {map(changes.excludedIngredients, ({ id, name }) => (
          <Fragment key={id}>
            <Typography.Text>{name}</Typography.Text>
            <br />
          </Fragment>
        ))}
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  if (subtype === EVENT_SUBTYPES.EXCLUDED_INGREDIENTS_DELETE) {
    return (
      <Timeline.Item key={event.id}>
        <Typography.Text>
          Deleted excluded ingredients from {original.name}:
        </Typography.Text>
        <br />
        {map(original.excludedIngredients, ({ id, name }) => (
          <Fragment key={id}>
            <Typography.Text>{name}</Typography.Text>
            <br />
          </Fragment>
        ))}
        <Typography.Text>
          {formatCreatedByText(createdAt, createdBy.name)}
        </Typography.Text>
      </Timeline.Item>
    )
  }

  return renderSimpleUpdateEvent(event, 'name')
}

export default renderDietEvent
